export default __webpack_public_path__ + "static/syndic@2x-7309d4152a2c7086791aeaf144e57940.png";